import React from 'react';
import { motion } from 'framer-motion';
import { Box, Typography, Container, alpha } from '@mui/material';
import {
  Storefront as BusinessIcon,
  Speed as SpeedIcon,
  Lock as SecureIcon,
} from '@mui/icons-material';
import { tokens } from '../../theme';

const SocialProofBar: React.FC = () => {
  const highlights = [
    {
      icon: <BusinessIcon />,
      title: 'For Growing Businesses',
      description: 'Works for any company size, from startups to scale-ups',
    },
    {
      icon: <SpeedIcon />,
      title: 'Connect It Yourself',
      description: 'Connect your tools with one-click OAuth',
    },
    {
      icon: <SecureIcon />,
      title: 'Tokens Encrypted at Rest',
      description: 'TLS in transit, and your OAuth tokens are encrypted in the database',
    },
  ];

  return (
    <Box
      component="section"
      sx={{
        py: { xs: 4, md: 6 },
        borderTop: `1px solid ${tokens.border.light}`,
        borderBottom: `1px solid ${tokens.border.light}`,
        background: alpha(tokens.background.subtle, 0.5),
        overflow: 'hidden',
      }}
    >
      <Container maxWidth="lg">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: { xs: 'column', md: 'row' },
              alignItems: 'center',
              justifyContent: 'center',
              gap: { xs: 3, md: 6 },
            }}
          >
            {highlights.map((item, index) => (
              <React.Fragment key={index}>
                <Box sx={{ textAlign: 'center', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1 }}>
                  <Box
                    sx={{
                      width: 48,
                      height: 48,
                      borderRadius: '12px',
                      background: alpha(tokens.primary.main, 0.08),
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      color: tokens.primary.main,
                      mb: 0.5,
                    }}
                  >
                    {React.cloneElement(item.icon, { sx: { fontSize: 24 } })}
                  </Box>
                  <Typography
                    variant="subtitle1"
                    sx={{
                      fontWeight: 700,
                      color: tokens.text.primary,
                    }}
                  >
                    {item.title}
                  </Typography>
                  <Typography variant="body2" sx={{ color: tokens.text.secondary, maxWidth: 220 }}>
                    {item.description}
                  </Typography>
                </Box>
                {index < highlights.length - 1 && (
                  <Box
                    sx={{
                      display: { xs: 'none', md: 'block' },
                      width: '1px',
                      height: 40,
                      background: tokens.border.light,
                      opacity: 0.5,
                    }}
                  />
                )}
              </React.Fragment>
            ))}
          </Box>
        </motion.div>
      </Container>
    </Box>
  );
};

export default SocialProofBar;
